// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__LEshi","upload":"Small_upload__3MZz9","imageWrap":"Small_imageWrap__2x03f","removeBtn":"Small_removeBtn__35zdy"};